import React, { useState, useEffect } from "react";
import { Row, Col, Avatar, Image } from "antd";
import { CalendarOutlined, UserOutlined } from "@ant-design/icons";
import MainHeader from "../../../../common/MainHeader";
import { getAge } from "../../../../../utilities/Utilities";
import defaultMale from "../../../../../assets/images/defaultMale.png";
import defaultFemale from "../../../../../assets/images/defaultFemale.png";

export default function UserBasicInfo(props) {
  const [userProfileInfo, setUserProfile] = useState(null);
  const [userProfilePic, setUserProfilePic] = useState(null);
  const [profileCode, setProfileCode] = useState(null);
  const [profileCodeId, setProfileCodeId] = useState(null);

  useEffect(() => {
    if (props?.profileInfo) {
      setUserProfile(props?.profileInfo);
    } else {
      setUserProfile(null);
    }

    if (props?.profilePic) {
      setUserProfilePic(props?.profilePic);
    } else {
      setUserProfilePic(null);
    }

    if (props?.profileCode) {
      setProfileCode(props?.profileCode);
    } else {
      setProfileCode(null);
    }

    if (props?.profileInfo?.profileCodeId) {
      setProfileCodeId(props?.profileInfo?.profileCodeId);
    } else {
      setProfileCodeId(null);
    }
  }, [props]);

  const LabelValue = (label, value) => {
    return (
      <div>
        <div
          style={{ color: "#767676", fontSize: "12px", marginBottom: "3px" }}
        >
          <span>{label}</span>
        </div>
        <div
          style={{
            color: "#000",
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "8px",
          }}
        >
          <span>{value}</span>
        </div>
      </div>
    );
  };

  return (
    <Col span={24}>
      <Row gutter={[8, 8]} justify="space-between">
        <Col>
          <Row gutter={[8, 8]}>
            <Col>
              {userProfilePic ? (
                <Image
                  src={userProfilePic}
                  width={80}
                  height={80}
                  style={{
                    borderRadius: "10px",
                    background: "#d5d5d5",
                    objectFit: "cover",
                    border: "1px solid #f5f5f5",
                  }}
                />
              ) : userProfileInfo?.firstName ? (
                <Avatar
                  shape="square"
                  size={80}
                  style={{ background: "#6a347d" }}
                >
                  <span
                    style={{
                      fontSize: "36px",
                      color: "#FFF",
                      textTransform: "uppercase",
                    }}
                  >
                    {userProfileInfo?.firstName?.charAt(0)}
                  </span>
                </Avatar>
              ) : (
                <Avatar
                  shape="square"
                  size={80}
                  src={
                    userProfileInfo?.gender === "Female"
                      ? defaultFemale
                      : defaultMale
                  }
                />
              )}
            </Col>
            <Col>
              <MainHeader
                title={
                  userProfileInfo?.firstName + " " + userProfileInfo?.lastName
                }
              />
              <div
                style={{
                  color: "#a5a5a5",
                  marginTop: "5px",
                  fontWeight: "bold",
                }}
              >
                <UserOutlined /> {userProfileInfo?.nickName || " "}{" "}
                <span>
                  [ {userProfileInfo?.gender?.charAt(0).toUpperCase() || ""} ]
                </span>
              </div>
              <div style={{ color: "#a5a5a5", marginTop: "5px" }}>
                <CalendarOutlined />{" "}
                <span style={{ fontWeight: "bold" }}>
                  {userProfileInfo?.birthDate &&
                    getAge(userProfileInfo?.birthDate)}{" "}
                  {" Year(s)"}
                </span>
              </div>
              <div style={{ color: "#a5a5a5" }}>
                <span style={{ fontWeight: "normal" }}>
                  ( {userProfileInfo?.birthDate || ""} )
                </span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          {LabelValue("Acc#", profileCode || "N/A")}
          {LabelValue("ID", profileCodeId || "N/A")}
        </Col>
      </Row>
    </Col>
  );
}
